// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__L48jK","sub-headline":"Quote_sub-headline__h_rt0"};